// extracted by mini-css-extract-plugin
module.exports = {"chartBox":"ScatterPlot_chartBox__23aBC","chartTitle":"ScatterPlot_chartTitle__1nxsk","chart":"ScatterPlot_chart__6MM17"};